<template>
  <v-radio-group
    v-bind="$attrs"
    class="theme-radio-group"
    :value="value"
    v-on="$listeners"
    @change="$emit('input', $event)"
  >
    <slot />
  </v-radio-group>
</template>

<script>
export default {
  name: "ThemedRadioGroup",
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number, Boolean],
      default: null,
    },
  },
};
</script>

<style scoped>
.theme-radio-group {
  margin: 0;
  padding: 0;
}

.theme-radio-group ::v-deep .v-radio-group {
  margin: 0;
  padding: 0;
}

.theme-radio-group ::v-deep .v-radio {
  margin: 0;
  padding: 0;
  margin-right: 16px;
}

.theme-radio-group ::v-deep .v-radio:last-child {
  margin-right: 0;
}

/* Label */
.theme-radio-group ::v-deep .v-radio .v-label {
  color: var(--color-text);
  font-size: 14px;
  font-weight: 500;
  padding: 0;
  margin: 0;
}

/* Inactive radio icon color */
.theme-radio-group ::v-deep .v-radio:not(.v-item--active) .v-icon {
  color: var(--color-text) !important;
}

/* Active icon */
.theme-radio-group ::v-deep .v-radio.v-item--active .v-icon {
  color: var(--color-secondary) !important;
}

/* Ripple (click effect) */
.theme-radio-group ::v-deep .v-radio .v-input--selection-controls__ripple {
  display: none;
}

/* Radio button border (the circle ring) */
.theme-radio-group ::v-deep .v-radio__input__background {
  border-color: var(--color-secondary-light) !important;
}

/* Active radio filled circle */
.theme-radio-group
  ::v-deep
  .v-radio.v-item--active
  .v-radio__input__background {
  border-color: var(--color-secondary) !important;
  background-color: var(--color-secondary) !important;
}

/* Remove input padding */
.theme-radio-group ::v-deep .v-input__control {
  margin: 0;
  padding: 0;
}

.theme-radio-group ::v-deep .v-input__slot {
  margin: 0;
  padding: 0;
}

/* Remove radio group wrapper padding */
.theme-radio-group ::v-deep .v-input--radio-group__input {
  margin: 0;
  padding: 0;
}
</style>
